export default __webpack_public_path__ + "static/media/ic_seemedik_not_with_text.e0ab5592.svg";